import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import DialogModal from '../../common/DialogModal';
import Button from '../../Parts/Button';
import Typography from "material-ui/Typography";
import Human from "../../Icons/Human";
import LetterOrderAttribute from "./parts/LetterOrderAttribute";
import Loader from '../../Parts/Loader';
import { Link } from "react-router-dom";
import { letterOrderStatusText } from "../../../utils/utils";
import { connect } from 'react-redux';
import { getOrderById } from '../../../redux/actions/OrderDetail';
import { getLetterOrdersAddresses } from '../../../redux/actions/LetterOrderDetail';

const styles = () => ({
  paper: {
    minHeight: '100vh;',
    background: "#F4F6F9",
    width: '600px',
  },

  contentContainer: {
    padding: '25px',
    margin: 0,
    textAlign: 'left',
    backgroundColor: '#FFFFFF',
  },

  sectionHead: {
    marginTop: '50px',
    paddingBottom: '12px',
    fontSize: '16px',
    borderBottom: '1px solid #ECEDEF',
  },

  keymanContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: "14px 0 15px",
    borderBottom: "1px solid #ECEDEF",
  },

  icon: {
    boxSizing: 'border-box',
    background: '#F2F6F9',
    width: '38px',
    height: '38px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '12px',
  },

  textContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    position: "relative",
    width: "calc(100% - 62px)",
  },

  heading: {
    fontSize: "14px",
    color: "#000000",
  },

  desc: {
    fontSize: "11px",
    color: "#71737B",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    width: "100%",
  },

  remaining: {
    display: 'flex',
    justifyContent: 'center',
    color: "#71737B",
    fontSize: "13px",
    marginTop: "15px",
  },

  buttonContainer: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'space-evenly',
    marginTop: '40px',
  },
});

class LetterOrderDetailDialog extends React.Component {
  componentDidMount() {
    this.props.getOrderById(this.props.status.letter_order_address.letter_order.order.id);
    this.props.getLetterOrdersAddresses(this.props.status.letter_order_address.letter_order.id,
      { page: 1, per_page: 5, paging: 1 }
    );
  }

  renderSectionHead = () => {
    const { classes } = this.props;

    return (
      <Typography
        className={classes.sectionHead}
        variant="subheading">
        {"送付先"}
      </Typography>
    );
  }

  renderLetterOrderAddresses = () => {
    const { classes, addresses } = this.props;

    return (
      <div className={classes.containerOuter}>
        {addresses.map((item) => (
          <div className={classes.keymanContainer} key={item.id}>
            <div className={classes.icon}>
              <Human width={20} height={20} color="#7C8297" />
            </div>
            <div className={classes.textContainer}>
              <Typography className={classes.heading}>
                {item.name ? item.name : item.company} 様
              </Typography>
              <Typography className={classes.desc}>
                {!item.company && !item.position
                  ? ""
                  : `${item.company ? item.company + " " : ""}${item.position ? item.position : ""
                  }`}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderButtons = () => {
    const { order, classes } = this.props;

    return (
      <div className={classes.buttonContainer}>
        <Button
          type="ghost"
          handleClickButton={() => this.props.toggleDialog(null)}
          text="キャンセル"
          size="large"
          style={{ width: "264px", background: '#ECEDEF', color: '#181819' }}>
        </Button>
        <Link to={`/orders/${order.id}`} style={{ textDecoration: "unset" }}>
          <Button
            size="large"
            text="全ての情報をみる"
            style={{ width: "264px", background: '#2E68F6', color: '#FFFFFF', marginLeft: '22px' }}
          >
          </Button>
        </Link>
      </div>
    )
  }

  render() {
    const { classes, toggleDialog, isOpen, order, addresses, isLoading } = this.props;

    return (
      <DialogModal
        title={(order && order.letter_order) ? letterOrderStatusText(order.letter_order) : 'レターが注文されました'}
        open={isOpen}
        onClose={() => toggleDialog(null)}
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >
        {(() => {
          if (isLoading) {
            return (<Loader type="color" size="large" />);
          } else {
            const remain = (order.letter_order.order_addresses_count - addresses.length);
            return (
              <div>
                <LetterOrderAttribute user={this.props.user} order={order} />
                {this.renderSectionHead()}
                {this.renderLetterOrderAddresses()}
                {remain > 0 && (
                  <div className={classes.remaining}>{"他" + remain + "件"}</div>
                )}
                {this.renderButtons()}
              </div>
            );
          }
        })()}
      </DialogModal>
    );
  }
}

LetterOrderDetailDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  getOrderById: PropTypes.func.isRequired,
  getLetterOrdersAddresses: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
  order: PropTypes.object,
  addresses: PropTypes.array.isRequired,
  status: PropTypes.object,
  isLoading: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
    isLoading: state.orderDetail.isOrderLoading || state.letterOrderDetail.isLoadingAddresses || !state.orderDetail.order || !state.orderDetail.order.letter_order || !state.letterOrderDetail.letterOrderAddresses.toIndexedSeq().toArray(),
    order: state.orderDetail.order,
    addresses: state.letterOrderDetail.letterOrderAddresses.toIndexedSeq().toArray(),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    // 注文
    getOrderById(id) {
      dispatch(getOrderById(id));
    },

    // 注文アドレス
    getLetterOrdersAddresses(id, data, overwrite) {
      dispatch(getLetterOrdersAddresses(id, data, overwrite));
    },
  };
};

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps
)(LetterOrderDetailDialog));



// WEBPACK FOOTER //
// ./src/components/Timeline/dialogs/LetterOrderDetailDialog.jsx